export default "__VITE_ASSET__DS8CYYu2__"